import request from "./request";

/**分页获取活动列表 
 * @param {Number} page
 * @param {Number} limit
 * 
*/
export async function getActives(page = 1, limit = 2) {
  return await request.get("/wxindex/active/index.html", {
    params: {
      page,
      limit
    }
  });
}

/**获取单一活动详情 
 * @param {Number} uid
 * @param {String} usertoken
 * @param {Number} aid
 * 
*/
export async function getActive(uid = 0, usertoken = "", aid = 0) {
  return await request.get(`/wxindex/active/detail.html?aid=${aid}`, {
    params: {
      uid,
      usertoken
    }
  })
}

/**立即报名活动
 * @param {Object} postInfo
 * aid,uid,realname,phone
 */
export async function postActive(postInfo) {
  return await request.post(`/wxindex/active/adduser.html`, postInfo)
}

/**取消活动报名 
 * @param {Object} cancelInfo
 * uid,usertoken,aid
*/
export async function cancelActive(cancelInfo) {
  return await request.post(`/wxindex/active/cancelUser.html`, cancelInfo)
}

/**签到填写签到码 
 * @param {Object} signUpInfo
 * uid,usertoken,aid,code
*/
export async function signUpActive(signUpInfo) {
  return await request.post(`/wxindex/active/qiandao.html`, signUpInfo)
}

/**获取最新报名人数列表
 * @param {Number} aid
 * @param {Number} limit
 */
export async function getActiveUserList(aid = 0, limit) {
  return await request.get(`/wxindex/active/userlist.html`, {
    params: {
      aid,
      limit
    }
  })
}

/**获取我参加过的活动列表
 * status(999:获取全部参加过的，0未开始的，1已经报名的，2报名结束的，3进行中的，4结束了的)
 * @param {Number} uid
 * @param {String} usertoken
 * @param {Number} regist_status
 * @param {Number} page
 * @param {Number} limit
 */
export async function myActive(uid = 0, usertoken = "", regist_status = 999, page = 1, limit = 8) {
  return await request.get(`/wxindex/active/myactive.html`, {
    params: {
      uid,
      usertoken,
      regist_status,
      page,
      limit
    }
  });
}
